import React, { Fragment, useState } from 'react'
import { bool } from 'prop-types'
import { Checkbox } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'
import GuestCheckout from './GuestCheckout'
import GuestRegister from './GuestRegister'


function GuestCheckoutWithRegistration({
  showVerificationNotice = false,
  useVerificationFlow = false,
}) {
  const [fields, setFields] = useState({
    email: '',
    wantsToRegister: false,
  })

  function updateEmail(email) {
    setFields({ ...fields, email })
  }

  function toggleChecked() {
    setFields({ ...fields, wantsToRegister: !fields.wantsToRegister })
  }

  function renderCheckbox() {
    return (
      <Fragment>
        <div className="row">
          <div className="col-12">
            <Checkbox
              checkedColor="primary"
              id="save-details-checkbox"
              label="Save my details for easier checkout later"
              isChecked={fields.wantsToRegister}
              onChange={toggleChecked}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12" />
        </div>
      </Fragment>
    )
  }

  return (
    <div className="guest-user-checkout-container">
      {fields.wantsToRegister ? (
        <GuestRegister
          email={fields.email}
          updateEmail={updateEmail}
          checkbox={renderCheckbox()}
          captchaId="registration-captcha"
        />
      ) : (
        <GuestCheckout
          showVerificationNotice={showVerificationNotice}
          useVerificationFlow={useVerificationFlow}
          email={fields.email}
          updateEmail={updateEmail}
          checkbox={renderCheckbox()}
          captchaId="registration-captcha"
        />
      )}
    </div>
  )
}

GuestCheckoutWithRegistration.propTypes = {
  showVerificationNotice: bool,
  useVerificationFlow: bool,
}

export default GuestCheckoutWithRegistration
